import { Component, ChangeDetectionStrategy } from '@angular/core';
import { ListView } from '../../list-view/list-view';
import { UnitsService } from '../../shared/services/units-service';
import { HttpClient } from '@angular/common/http';
import { EnvironmentUrl } from '../../shared/services/environment-url';

@Component({
  selector: 'app-units',
  imports: [ListView],
  templateUrl: './units.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './units.css',
})
export class Units {
  unitsService?: UnitsService;

  constructor(
    private http: HttpClient,
    private envUrl: EnvironmentUrl,
  ) {
    this.unitsService = new UnitsService(this.http, this.envUrl);
  }
}
